import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
// import RecordedCallDataGrid from "./RecordedCallDataGrid/RecordedCallDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecordedCalls } from "../../store/RecordedCalls/recordedCallsThunks";
import RecordedCallDataGrid from "./Components/RecordedCallDataGrid/RecordedCallDataGrid";
import { Paper, useTheme, useMediaQuery } from "@mui/material";
import PageTitle from "../../components/PageTitle";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import CustomToolbar from "./Components/RecordedCallDataGrid/CustomToolbar";
import SideModal from "../../components/SideModal";
import CreatePlaylistForm from "../Playlist/Components/CreatePlaylistForm/CreatePlaylistForm";
import { createPlaylist } from "../../store/Playlists/playlistsThunks";

function RecordedCall() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const recordedCalls = useSelector(
    (state) => state.recordedCalls.recordedCalls
  );
  const loading = useSelector((state) => state.recordedCalls.loading);
  const [searchQuery, setSearchQuery] = useState("");
  const [openCreatePlaylist, setOpenCreatePlaylist] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const gridApiRef = useRef(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [filterModel, setFilterModel] = useState({ items: [] });

  useEffect(() => {
    dispatch(fetchRecordedCalls({}));
  }, [dispatch]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    dispatch(fetchRecordedCalls({ search: query }));
  };

  const handleRefresh = () => {
    dispatch(fetchRecordedCalls({ search: searchQuery }));
  };

  const handleFilterClick = () => {
    if (gridApiRef.current) {
      gridApiRef.current.showFilterPanel();
    }
  };

  const handleColumnClick = () => {
    if (gridApiRef.current) {
      gridApiRef.current.showPreferences("columns");
    }
  };

  const handleCreatePlaylist = () => {
    setActiveStep(0);
    setOpenCreatePlaylist(true);
  };

  const handleCloseCreatePlaylist = () => {
    setOpenCreatePlaylist(false);
  };

  const handleCreatePlaylistFormSubmit = async (formData) => {
    try {
      dispatch(createPlaylist(formData));
      setOpenCreatePlaylist(false);
      setActiveStep(0);
    } catch (error) {
      console.error("Error submitting contact:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100vh",
        overflow: "hidden",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      {/* Fixed header section */}
      <Box
        sx={{
          // position: "sticky",
          // top: 0,
          // zIndex: 10,
          backgroundColor: (theme) => theme.palette.background.paper,
          p: isSmallScreen ? 1 : 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: isSmallScreen ? "flex-start" : "center",
            justifyContent: "space-between",
            gap: isSmallScreen ? 2 : 0,
          }}
        >
          <PageTitle
            title="Recorded Calls"
            subtitle="View and manage all recorded calls in the system"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              alignItems: isSmallScreen ? "stretch" : "center",
              gap: 2,
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <CustomToolbar
              onSearch={handleSearch}
              searchQuery={searchQuery}
              onRefresh={handleRefresh}
              onFilterClick={handleFilterClick}
              onColumnClick={handleColumnClick}
              isSmallScreen={isSmallScreen}
            />
            <Button
              startIcon={<AddIcon />}
              onClick={handleCreatePlaylist}
              variant="contained"
              size="small"
              fullWidth={isSmallScreen}
              sx={{
                backgroundColor: (theme) => theme.palette.background.button,
                color: (theme) => theme.palette.common.white,
                textTransform: "none",
                px: 2,
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.background.button,
                },
              }}
            >
              Create Playlist
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Content section */}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          height: "calc(100vh - 120px)",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "auto",
            "& .MuiDataGrid-root": {
              border: "none",
              backgroundColor: (theme) => theme.palette.background.paper,
              padding: 0,
              margin: 0,
            },
          }}
        >
          <RecordedCallDataGrid
            data={recordedCalls}
            loading={loading}
            searchQuery={searchQuery}
            onSearch={handleSearch}
            apiRef={gridApiRef}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            filterModel={filterModel}
            setFilterModel={setFilterModel}
          />
        </Paper>
      </Box>

      {/* Create Playlist Modal */}
      {openCreatePlaylist && (
        <SideModal
          open={openCreatePlaylist}
          onClose={handleCloseCreatePlaylist}
          title="Create Playlist"
        >
          <CreatePlaylistForm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            onSubmit={handleCreatePlaylistFormSubmit}
            selectedIds={selectedIds}
            filterModel={filterModel}
          />
        </SideModal>
      )}
    </Box>
  );
}

export default RecordedCall;
